import * as common from '@/store/common/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM_INIT = 'SEARCH_PARAM_INIT';

export default {
	...common,
	SEARCH_PARAM,
	STATE_INIT,
	SEARCH_PARAM_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO
};
